import { Tour } from "nextstepjs";

export const tours: Tour[] = [
  {
    tour: "applicationIntro",
    steps: [
      {
        icon: "📋",
        title: "tourApplicationIntroStep1Title",
        content: "tourApplicationIntroStep1Content",
        selector: "#applicationIntro1",
        side: "right",
        showControls: true,
        disableInteraction: true,
        showSkip: true,
      },
      {
        icon: "🧭",
        title: "tourApplicationIntroStep2Title",
        content: "tourApplicationIntroStep2Content",
        selector: "#applicationIntro2",
        side: "bottom-left",
        showControls: true,
        disableInteraction: true,
        showSkip: true,
      },
      {
        icon: "➕",
        title: "tourApplicationIntroStep3Title",
        content: "tourApplicationIntroStep3Content",
        selector: "#applicationIntro3",
        side: "top",
        showControls: true,
        disableInteraction: true,
        showSkip: true,
      },
      {
        icon: "🔍",
        title: "tourApplicationIntroStep4Title",
        content: "tourApplicationIntroStep4Content",
        selector: "#applicationIntro4",
        side: "right",
        showControls: true,
        disableInteraction: true,
        showSkip: true,
      },
      {
        icon: "📊",
        title: "tourApplicationIntroStep5Title",
        content: "tourApplicationIntroStep5Content",
        selector: "#applicationIntro5",
        side: "top-left",
        showControls: true,
        disableInteraction: true,
        showSkip: true,
      },
      {
        icon: "👆",
        title: "tourApplicationIntroStep6Title",
        content: "tourApplicationIntroStep6Content",
        selector: "#applicationIntro6",
        side: "top-left",
        showControls: true,
        disableInteraction: true,
        showSkip: true,
      },
      {
        icon: "✏️",
        title: "tourApplicationIntroStep7Title",
        content: "tourApplicationIntroStep7Content",
        selector: "#applicationIntro7",
        side: "left",
        showControls: true,
        disableInteraction: true,
        showSkip: true,
      },
    ],
  },
];